/**
 * The shelf's revision, as a render.
 *
 * `core/docStore.ts` counts every change to the document mirror and announces
 * it. This turns that into a subscription React honours, so a memo built from
 * the LIBRARY — every stored exploration rather than the open one — recomputes
 * when another tab saves. Without it the counter fixed the cache key and left
 * the reader stale: the cross-tab path resolves asynchronously with nothing in
 * React subscribed to it, so a twin refuted next door stayed on screen until
 * some unrelated edit happened to re-render the card anyway.
 *
 * `docsRevision` is the snapshot and it is a number, so it is stable between
 * announcements — which is what `useSyncExternalStore` requires and what a
 * freshly built object would fail.
 */

import { useSyncExternalStore } from 'react'
import { docsRevision, subscribeDocs } from '../core/docStore'

export const useDocs = (): number => useSyncExternalStore(subscribeDocs, docsRevision, docsRevision)
